<template>
  <el-drawer
    title="发起审批"
    :visible.sync="drawer"
    destroy-on-close
    :modal-append-to-body="false"
    append-to-body
    :wrapperClosable="false" 
    custom-class="widthCommon"
    @close="close"
  >
    <div class="ul">
      <div class="liItem" v-for="(item, index) in dataList" :key="index" @click="goodsDetail(item)">
        <img :src="item.icon" alt="" class="icon" />
        <span class="title">{{ item.title }}</span>
      </div>
    </div>
    <ExpenseAccount ref="ExpenseAccount" />
    <CardReplacement ref="CardReplacement" />
    <leaveApplication ref="LeaveApplication" />
    <OfficialBusiness ref="OfficialBusiness" />
    <ApplyWithSeal ref="ApplyWithSeal" />
    <RefundApplication ref="RefundApplication" />
    <Purchase ref="Purchase" />
    <DiscountApproval ref="DiscountApproval" />
    <ContractRefund ref="ContractRefund" />
    <VoidModule ref="VoidModule" />
    <ContractDiscounts ref="ContractDiscounts" />
    <MaterialRequisition ref="MaterialRequisition" />
  </el-drawer>
</template>

<script>
import router from '@/router'
import OfficialBusiness from './components/officialBusiness/index.vue'
import leaveApplication from './components/leaveApplication/index.vue'
import CardReplacement from './components/cardReplacement/index.vue'
import ExpenseAccount from './components/expenseAccount/index.vue'
import ApplyWithSeal from './components/applyWithSeal/index.vue'
import Purchase from './components/purchase/index.vue'
import RefundApplication from './components/refundApplication/index.vue'
import DiscountApproval from './components/discountApproval/index.vue'
import ContractDiscounts from './components/contractDiscounts/index.vue'
import ContractRefund from './components/contractRefund/index.vue'
import MaterialRequisition from './components/materialRequisition/index.vue'
import VoidModule from './components/VoidModule/index.vue'
export default {
  components: {
    VoidModule,
    ContractRefund,
    ContractDiscounts,
    RefundApplication,
    leaveApplication,
    CardReplacement,
    OfficialBusiness,
    ExpenseAccount,
    ApplyWithSeal,
    Purchase,
    DiscountApproval,
    MaterialRequisition,
  },
  data() {
    return {
      drawer: false,
    }
  },
  computed: {
    dataList() {
      const tabs = [
        { components: 'LeaveApplication', icon: require('@/assets/image/approve/image_1.png'), title: '请假申请', power: 'leaveApplication' },
        { components: 'CardReplacement', icon: require('@/assets/image/approve/image_2.png'), title: '补卡申请', power: 'cardApplication' },
        { components: 'OfficialBusiness', icon: require('@/assets/image/approve/image_3.png'), title: '出差申请', power: 'officialBusiness' },
        { components: 'ExpenseAccount', icon: require('@/assets/image/approve/image_4.png'), title: '报销申请', power: 'expenseAccount' },
        { components: 'ApplyWithSeal', icon: require('@/assets/image/approve/image_5.png'), title: '用章申请', power: 'applySeal' },
        { components: 'Purchase', icon: require('@/assets/image/approve/image_6.png'), title: '采购申请', power: 'applyPurchase' },
        { components: 'MaterialRequisition', icon: require('@/assets/image/approve/image_7.png'), title: '物资领用', power: 'materialRequisition' },
        { components: 'DiscountApproval', icon: require('@/assets/image/approve/image_8.png'), title: '优惠申请', power: 'discountApproval' },
        { components: 'RefundApplication', icon: require('@/assets/image/approve/image_9.png'), title: '退款申请', power: 'refundApplication' },
         { components: 'VoidModule', icon: require('@/assets/image/approve/image_12.png'), title: '财务作废', power: 'voidPermission' },
        { components: 'ContractDiscounts', icon: require('@/assets/image/approve/image_10.png'), title: '合同优惠', power: 'contractDiscounts' },
        { components: 'ContractRefund', icon: require('@/assets/image/approve/image_11.png'), title: '合同退款', power: 'contractRefund' },
        
      ]
      return tabs
        .map(item => {
          if (this.hiddenTableColumn([item.power])) return item
        })
        .filter(item => item != undefined)
    },
  },
  methods: {
    goodsDetail(item) {
      const { components } = item
      this.$refs[components].drawer = true
    },

    close() {
      // 刷新当前页面
      const { fullPath } = router.currentRoute
      if (fullPath == '/welcome/welcome') return
      const flag = fullPath.split('/')[1]

      if (flag !== 'approvalCenter') return
      router.replace({
        path: '/redirect' + fullPath,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.ul {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 24px 32px;
  .liItem {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 24px 16px;
    border: 1px solid #f0f2f5;
    border-radius: 8px;
    .icon {
      width: 36px;
      height: 36px;
      margin-right: 16px;
    }
    .title {
      font-size: 16px;
      color: #3d3d3d;
      font-weight: 500;
    }
  }
}
</style>
